import dom from '../../utils/dom';
import { loadModal } from '../../AsyncLoader';
import PaymentPlanService from './PaymentPlanService';
import ContentStorage, { ComponentKeys } from '../../tnew/content/ContentStorage';
import PaymentPlanErrorMessage from './PaymentPlanErrorMessage';
import {AppliedPaymentPlanHeading} from "../../shared/UserFacingIdentifiers";

function getModalProperties() {
  const key = ComponentKeys.PAYMENT_PLANS;

  return {
    title: ContentStorage.get(key, 'PaymentPlanSummarySectionSubhead'),
    labelBtnSubmit: ContentStorage.get(key, 'ApplyPaymentPlanButtonLabel'),
    labelBtnCancel: ContentStorage.get(key, 'CancelButtonLabel'),
  };
}

export async function confirmSelectedPaymentPlanBillingSchedule(detailsHtml, scheduleId) {
  const Modal = await loadModal();

  const $form = dom.makeElement('form', { id: 'tn-payment-plan-confirmation-form' });

  $form.innerHTML = detailsHtml;

  const $errorMessageContainer = dom.makeElement('div');

  dom.prepend($form, $errorMessageContainer);

  const errorMessage = new PaymentPlanErrorMessage($errorMessageContainer);

  const { title, labelBtnSubmit, labelBtnCancel } = getModalProperties();

  return new Promise((resolve) => {
    const modal = Modal.presentForm({
      $form,
      title,
      labelBtnSubmit,
      labelBtnCancel,
      onCancel: () => resolve({ wasCancelled: true }),
      onSubmit: async () => {
        errorMessage.hide();

        const { isSuccessful } = await PaymentPlanService.applyPaymentPlan(scheduleId);

        if (!isSuccessful) {
          modal.enableForm();

          errorMessage.show();

          modal.scrollToTop();

          return;
        }
        
        window.location.assign(`/cart/payment#${AppliedPaymentPlanHeading}`);
        window.location.reload();
      },
    });
  });
}
